exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-xs[data-v-f996a3f6] {\n    font-size: 0.6em;\n}\n.table-sm td[data-v-f996a3f6] {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n    vertical-align: middle;\n}\n.table-stripe[data-v-f996a3f6]  {\n    background-color:rgba(0,0,0,.05);\n}\n.input-group[data-v-f996a3f6] {\n    align-self: flex-start;\n}\ni[data-v-f996a3f6] { vertical-align: middle !important;\n}\n", ""]);

// exports
